import React from "react";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

function CustomQuote({children, icon = <FormatQuoteIcon />}) {
    return (
        <div className={"custom-quote"}>
            <span className={"custom-quote-icon"}>{icon}</span>
            {children}
        </div>
    );
}

export default CustomQuote;
